module.exports = __webpack_public_path__ + "bbdfe57bb16374e5db56122977e4dd33.png";